import gql from "graphql-tag";
import { infoContent } from '~/graphql/queries/infoContent'

export const infoQuery = gql`
  query Info {
    ${infoContent}
  }
`